import { Chip } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Root = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'center',
  fontWeight: 'bold',
  left: 0,
  pointerEvents: 'none',
  position: 'absolute',
  right: 0,
  textTransform: 'uppercase',
}));

export const StyledChip = styled(Chip)(({ theme }) => ({
  padding: `${theme.spacing(0.25)} ${theme.spacing(2)}`,
  borderRadius: 25,
}));

export const TopChip = styled(StyledChip)({
  borderBottomLeftRadius: 0,
  borderBottomRightRadius: 0,
  marginBottom: -2,
});

export const RightChip = styled(StyledChip)({
  borderTopLeftRadius: 0,
  borderBottomLeftRadius: 0,
  marginLeft: -2,
});

export const BottomChip = styled(StyledChip)({
  borderTopLeftRadius: 0,
  borderTopRightRadius: 0,
  marginTop: -2,
});

export const LeftChip = styled(StyledChip)({
  borderTopRightRadius: 0,
  borderBottomRightRadius: 0,
  marginRight: -2,
});

export const DivTopBorder = styled('div')(({ theme }) => ({
  borderStyle: 'solid',
  borderColor: theme.palette.primary.main,
  borderTopWidth: 2,
  position: 'relative',
}));

export const DivBottomBorder = styled('div')(({ theme }) => ({
  borderStyle: 'solid',
  borderColor: theme.palette.primary.main,
  borderBottomWidth: 2,
  position: 'relative',
}));

export const DivLeftBorder = styled('div')(({ theme }) => ({
  borderStyle: 'solid',
  borderColor: theme.palette.primary.main,
  borderLeftWidth: 2,
  position: 'relative',
}));

export const DivRightBorder = styled('div')(({ theme }) => ({
  borderStyle: 'solid',
  borderColor: theme.palette.primary.main,
  borderRightWidth: 2,
  position: 'relative',
}));
